var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3808 13.2268C45.532 12.7282 26.2885 6.90249 17.0443 25.8896C13.6969 32.7266 9.0392 50.1896 19.1096 60.0749C26.8298 67.6668 38.7519 71.3133 48.0674 67.4105C80.7998 53.6794 67.61 16.6453 48.3808 13.2268Z",
    fill: "#F1F5F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 53.3333V29.3333C32.0003 28.626 32.2813 27.9478 32.7814 27.4477C33.2815 26.9476 33.9597 26.6666 34.667 26.6666H45.3337C46.0409 26.6666 46.7192 26.9476 47.2193 27.4477C47.7194 27.9478 48.0003 28.626 48.0003 29.3333V53.3333M32.0003 53.3333H48.0003M32.0003 53.3333H29.3337C28.6264 53.3333 27.9481 53.0523 27.448 52.5522C26.9479 52.0521 26.667 51.3739 26.667 50.6666V42.6666C26.667 41.9594 26.9479 41.2811 27.448 40.781C27.9481 40.2809 28.6264 40 29.3337 40H32.0003M48.0003 53.3333H50.667C51.3742 53.3333 52.0525 53.0523 52.5526 52.5522C53.0527 52.0521 53.3337 51.3739 53.3337 50.6666V38.6666C53.3337 37.9594 53.0527 37.2811 52.5526 36.781C52.0525 36.2809 51.3742 36 50.667 36H48.0003M37.3337 32H42.667M37.3337 37.3333H42.667M37.3337 42.6666H42.667M37.3337 48H42.667",
    stroke: "#6D33FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 53.3333V29.3333C32.0003 28.626 32.2813 27.9478 32.7814 27.4477C33.2815 26.9476 33.9597 26.6666 34.667 26.6666H45.3337C46.0409 26.6666 46.7192 26.9476 47.2193 27.4477C47.7194 27.9478 48.0003 28.626 48.0003 29.3333V53.3333M32.0003 53.3333H48.0003M32.0003 53.3333H29.3337C28.6264 53.3333 27.9481 53.0523 27.448 52.5522C26.9479 52.0521 26.667 51.3739 26.667 50.6666V42.6666C26.667 41.9594 26.9479 41.2811 27.448 40.781C27.9481 40.2809 28.6264 40 29.3337 40H32.0003M48.0003 53.3333H50.667C51.3742 53.3333 52.0525 53.0523 52.5526 52.5522C53.0527 52.0521 53.3337 51.3739 53.3337 50.6666V38.6666C53.3337 37.9594 53.0527 37.2811 52.5526 36.781C52.0525 36.2809 51.3742 36 50.667 36H48.0003M37.3337 32H42.667M37.3337 37.3333H42.667M37.3337 42.6666H42.667M37.3337 48H42.667",
    stroke: "url(#paint0_linear_47000_23403)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 53.3333V29.3333C32.0003 28.626 32.2813 27.9478 32.7814 27.4477C33.2815 26.9476 33.9597 26.6666 34.667 26.6666H45.3337C46.0409 26.6666 46.7192 26.9476 47.2193 27.4477C47.7194 27.9478 48.0003 28.626 48.0003 29.3333V53.3333M32.0003 53.3333H48.0003M32.0003 53.3333H29.3337C28.6264 53.3333 27.9481 53.0523 27.448 52.5522C26.9479 52.0521 26.667 51.3739 26.667 50.6666V42.6666C26.667 41.9594 26.9479 41.2811 27.448 40.781C27.9481 40.2809 28.6264 40 29.3337 40H32.0003M48.0003 53.3333H50.667C51.3742 53.3333 52.0525 53.0523 52.5526 52.5522C53.0527 52.0521 53.3337 51.3739 53.3337 50.6666V38.6666C53.3337 37.9594 53.0527 37.2811 52.5526 36.781C52.0525 36.2809 51.3742 36 50.667 36H48.0003M37.3337 32H42.667M37.3337 37.3333H42.667M37.3337 42.6666H42.667M37.3337 48H42.667",
    stroke: "url(#paint1_linear_47000_23403)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47000_23403",
    x1: 24.8995,
    y1: 32.0942,
    x2: 68.4858,
    y2: 66.4225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180138,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47000_23403",
    x1: 24.8995,
    y1: 32.0942,
    x2: 54.4211,
    y2: 47.8601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompany);
export default __webpack_public_path__ + "static/media/icon-company.2a9b4e9bf46f53e6d544fb323c60986d.svg";
export { ForwardRef as ReactComponent };